var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1.86938 11.2722C1.86938 11.2722 1.96405 12.4309 1.98605 12.7962C2.01538 13.2862 2.20472 13.8335 2.52072 14.2135C2.96672 14.7522 3.49205 14.9422 4.19338 14.9435C5.01805 14.9449 11.0147 14.9449 11.8394 14.9435C12.5407 14.9422 13.0661 14.7522 13.5121 14.2135C13.8281 13.8335 14.0174 13.2862 14.0474 12.7962C14.0687 12.4309 14.1634 11.2722 14.1634 11.2722",
    stroke: "#003056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.664 4.50718V4.25984C5.664 3.44651 6.32267 2.78784 7.136 2.78784H8.85733C9.67 2.78784 10.3293 3.44651 10.3293 4.25984L10.33 4.50718",
    stroke: "#003056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99666 12.0729V11.2102",
    stroke: "#003056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.83325 6.54697V8.8583C3.11192 9.70163 4.64392 10.2923 6.32525 10.5263C6.52659 9.7923 7.18859 9.2543 7.99325 9.2543C8.78525 9.2543 9.46059 9.7923 9.64859 10.533C11.3366 10.299 12.8746 9.7083 14.1599 8.8583V6.54697C14.1599 5.41763 13.2513 4.5083 12.1219 4.5083H3.87792C2.74859 4.5083 1.83325 5.41763 1.83325 6.54697Z",
    stroke: "#003056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.e7e6fc53082585bf9d0c7a73e1679b09.svg";
export { ForwardRef as ReactComponent };